import styled from 'styled-components';
import { theme } from '../globalStyle/global-styles';

interface ITextareaProps {
  lang?: string;
}
interface LabelProps {
  lang?: string;
}

export const TextareaWrapper = styled.div`
  position: relative;
  margin-bottom: ${theme.space_size};
  display: flex;
  align-items: center;
`;

export const Textarea = styled.textarea<ITextareaProps>`
  width: 100%;
  height: 152px;
  border: 1px solid #ebebeb;
  resize: none;
  font-family: ${theme.fonts.Medium};
  font-size: 13px;
  color: ${theme.colours.blackText};
  background-color: ${theme.colours.white};
  padding: 40px 12px 0 12px;
  border-radius: 8px;
  outline: none;
  text-align: ${(props) => (props.lang === 'en' ? 'left' : 'right')};

  &:focus {
    border: 1px solid ${theme.colours.white};
  }

  &:not(:placeholder-shown) + label,
  &:focus + label {
    transform: translateY(-10px);
    font-size: 13px;
    font-weight: 600;
    padding: 0 4px;
    background-color: ${theme.colours.white};
  }

  &:not(:focus) + label {
    color: #808080;
  }
`;

export const Label = styled.label<LabelProps>`
  position: absolute;
  top: 20px;
  left: ${(props) => (props.lang === 'en' ? '12px' : 'auto')};
  right: ${(props) => (props.lang === 'ar' ? '12px' : 'auto')};
  font-size: 14px;
  color: ${theme.colours.SpanishGray};
  transition: all 0.3s ease;
  background-color: ${theme.colours.white};
  padding: 0 4px;
`;
